module.exports = __webpack_public_path__ + "f0b955522d3a609415cc7dc45287166f.MP3";